module.exports = __webpack_public_path__ + "static/img/img_cabinet.541d4579.png";